import gql from "graphql-tag";

export const REFER_A_FARMER_MUTATION = gql`
  mutation referAFarmer($farmer_name: String!, $farmer_email: String!, $farmer_telephone: String!, $comments: String!) {
    referAFarmer(farmer_name: $farmer_name, farmer_email: $farmer_email, farmer_telephone: $farmer_telephone, comments: $comments, )
  }
`;